export default "__VITE_ASSET__BsUXWXgl__"